import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  rating: number;
  title: string;
  text: string;
  name: string;
  location: string;
  imageUrl?: string;
}
export function TestimonialCard({
  rating,
  title,
  text,
  name,
  location,
  imageUrl
}: TestimonialCardProps) {
  return <div className="bg-pink-50 border-2 border-pink-200 rounded-lg p-5" data-id="element-330">
      <div className="flex gap-1 mb-2" data-id="element-331">
        {[...Array(rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-pink-500 text-pink-500" data-id="element-332" />)}
      </div>
      <h4 className="font-bold text-gray-900 mb-2" data-id="element-333">{title}</h4>
      <p className="text-sm text-gray-700 mb-3 italic" data-id="element-334">"{text}"</p>
      <div className="flex items-center gap-3" data-id="element-335">
        {imageUrl && <img src={imageUrl} alt={name} className="w-12 h-12 rounded-full object-cover" data-id="element-336" />}
        <div className="text-sm" data-id="element-337">
          <div className="font-semibold text-gray-900" data-id="element-338">{name}</div>
          <div className="text-gray-600" data-id="element-339">{location}</div>
        </div>
      </div>
    </div>;
}